import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const textWithIconInBackgroundStyle = (theme) => ({
	wrapper: {
		textAlign: 'center',
		'& > div': {
			position: 'relative',
			'& svg': {
				fontSize: '64px',
				color: blackColors[6],
			},
			'& > div': {
				position: 'absolute',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)',
			},
		},
		'& > div:nth-child(2)': {
			display: 'inline-block',
		},
		'&:first-of-type': {
			marginRight: '80px',
			[theme.breakpoints.down('xs')]: {
				marginRight: '30px',
			},
		},
	},
});

export default textWithIconInBackgroundStyle;
